import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import { stylesResult } from "../../styles/result";
import clsx from "clsx";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { MoreInfoType, ResultCardIconsType } from "./helpers/types";

interface ResultCardState {
  expanded: boolean;
}

interface ResultCardProps {
  classes: any;
  title: string;
  type: ResultCardIconsType;
  data: MoreInfoType[];
  restDate: string;
  leftTimeRest?: number;
  percentual: string;
  leftTimeFull?: string | boolean;
}

class ResultCard extends Component<ResultCardProps, ResultCardState> {
  constructor(props: ResultCardProps) {
    super(props);
    this.state = {
      expanded: false,
    };
  }
  handleExpandClick = () => {
    // eslint-disable-next-line no-invalid-this
    this.setState({ expanded: !this.state.expanded });
  };
  render() {
    const {
      classes,
      title,
      type,
      data,
      leftTimeFull,
      percentual,
      restDate,
      leftTimeRest,
    } = this.props;
    const { handleExpandClick } = this;
    let icon;
    if (type === "points") icon = `fas fa-calculator`;
    else if (type === "toll") icon = `fas fa-receipt`;
    else if (type === "minimal") icon = `fas fa-stopwatch`;
    else if (type === "special") icon = `fas fa-user-tag`;
    else if (type === "time") icon = `far fa-clock`;

    return (
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" className={classes.cardAvatar}>
              <i className={`${icon} ${classes.cardAvatarIcon}`} />
            </Avatar>
          }
          className={classes.cardHeader}
          title={title}
        />
        <CardContent>
          <Grid justify="space-around" container spacing={3}>
            <Grid justify="center" container item xs={12} md={4} spacing={3}>
              <div className={classes.container}>
                <i className={`${icon} ${classes.cardIcon}`} />
              </div>
            </Grid>
            <Grid justify="center" container item xs={12} md={8} spacing={3}>
              <div className={classes.textWithIcon}>
                <i className={`far fa-calendar-alt ${classes.dataIcon}`} />
                <Typography className={classes.dataText}>
                  {"Você podera se aposentar a partir de "}
                </Typography>
                <Typography variant="h6" className={classes.dataText}>
                  {restDate}
                </Typography>
              </div>
              <div
                className={clsx(
                  leftTimeRest === undefined && classes.hide,
                  leftTimeRest !== undefined && classes.textWithIcon
                )}
              >
                <i className={`far fa-clock ${classes.dataIcon}`} />
                <Typography className={classes.dataText}>
                  {"Faltariam "}
                </Typography>
                <Typography variant="h6" className={classes.dataText}>
                  {leftTimeRest}
                </Typography>
                <Typography className={classes.dataText}>
                  {" ano(s) para se aposentar"}
                </Typography>
              </div>
              <div className={classes.textWithIcon}>
                <i className={`far fa-money-bill-alt ${classes.dataIcon}`} />
                <Typography variant="h6" className={classes.dataText}>
                  {percentual}
                </Typography>
              </div>
              <div
                className={clsx(
                  leftTimeFull === false && classes.hide,
                  leftTimeFull !== undefined && classes.textWithIcon
                )}
              >
                <i
                  className={clsx(
                    `fas fa-suitcase ${classes.dataIcon}`,
                    leftTimeFull === false && classes.hide
                  )}
                />
                <Typography variant="h6" className={classes.dataText}>
                  {leftTimeFull}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions disableSpacing>
          <Typography
            className={clsx(
              classes.actionText,
              !this.state.expanded && classes.hide
            )}
            align="center"
            variant="h5"
          >
            Condição Atual
          </Typography>
          <IconButton
            id={"more-button"}
            className={clsx(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="show more"
          >
            <ExpandMore className={classes.moreIcon} />
          </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            {data.map((info, index) => {
              return (
                <div
                  key={`${Math.random() * 100000}-${index}`}
                  className={classes.dataWithIcon}
                >
                  <i
                    className={
                      info.state
                        ? `fas  fa-check ${classes.yesIcon}`
                        : `fas  fa-times ${classes.noIcon}`
                    }
                  />
                  <Typography className={classes.dataText}>
                    {info.text}
                  </Typography>
                </div>
              );
            })}
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

export default withStyles(stylesResult)(ResultCard);
